import { IntlShape } from 'react-intl'

import { ProviderTask, ProviderTslTaskArguments } from '@lyrahealth-inc/shared-app-logic/src/models/providers/Providers'

export const getTslDateRange = (
  intl: IntlShape,
  startDate: string | null | undefined,
  endDate: string | null | undefined,
): string =>
  startDate && endDate
    ? `${startDate} – ${endDate}`
    : intl.formatMessage({ defaultMessage: 'All dates', description: 'TSL task date range with no date filter' })

export const toTslTaskRow = (task: ProviderTask<ProviderTslTaskArguments>, intl: IntlShape) => ({
  taskId: task.id,
  letterId: task.resource_id ?? '',
  clientName:
    task.arguments?.patient_display_name?.trim() ||
    intl.formatMessage({ defaultMessage: 'Client', description: 'Fallback client name for a TSL task' }),
  dateRange: getTslDateRange(intl, task.arguments?.start_date, task.arguments?.end_date),
  date: task.create_datetime ?? null,
})
